import { render, staticRenderFns } from "./NordContainerPage.vue?vue&type=template&id=e46eba24&"
import script from "./NordContainerPage.vue?vue&type=script&lang=js&"
export * from "./NordContainerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Nord\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e46eba24')) {
      api.createRecord('e46eba24', component.options)
    } else {
      api.reload('e46eba24', component.options)
    }
    module.hot.accept("./NordContainerPage.vue?vue&type=template&id=e46eba24&", function () {
      api.rerender('e46eba24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/pages/NordContainerPage.vue"
export default component.exports